module.exports = __webpack_public_path__ + "1e3e3ae0638c2c8bed76b8f2da37ef37.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/jewelry-photo/img/summary-jewelry-placeholder@2x.png
// module id = 778
// module chunks = 0